import classnames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { contentfulViews, components } from '@glowforge/ui-common';
import { instructionsPropTypes, stepPropTypes } from 'app/selectors/support';
import Video from '../video';

import './steps.less';

const { MediaObject } = contentfulViews;
const { Markdown } = components;

const Step = (props) => {
  const assets = [];
  if (props.video) {
    if (props.video && props.video.length) {
      let src;
      let poster;
      props.video.forEach((content) => {
        const { contentType, url } = content.fields.file;
        if (contentType === 'video/mp4') {
          src = url;
        } else {
          poster = url;
        }
      });
      assets.push(<Video key='0' src={src} poster={poster} />);
    }
  }

  if (props.image) {
    const { contentType, url } = props.image.fields.file;
    if (contentType === 'video/mp4') {
      assets.push(<Video key='1' src={url} />);
    } else {
      assets.push(<MediaObject key='1' {...props.image.fields} />);
    }
  }

  if (props.imageTwo) {
    const { contentType, url } = props.imageTwo.fields.file;
    if (contentType === 'video/mp4') {
      assets.push(<Video key='2' src={url} />);
    } else {
      assets.push(<MediaObject key='2' {...props.imageTwo.fields} />);
    }
  }

  const summary = props.summary
    ? <Markdown className='paragraph' source={props.summary} /> : null;

  const classNames = classnames('Step', { multiImage: assets.length > 1 });

  return (
    <div className={classNames}>
      <div className='instructions'>
        <div className='count'>{props.count}</div>
        <div className='text'>
          <h4 className='header'>{props.title}</h4>
          <div className='summary'>{summary}</div>
        </div>
      </div>
      <div className='image'>
        {assets}
      </div>
    </div>
  );
};

Step.propTypes = {
  ...stepPropTypes,
  count: PropTypes.number.isRequired,
  unboxingUpdateEnabled: PropTypes.bool,
};

Step.defaultProps = {
  unboxingUpdateEnabled: false,
};

const Steps = (props) => {
  const steps = _.map(props.steps, (step, index) => (
    <Step
      key={index}
      {...step.fields}
      count={parseInt(index, 0) + 1}
      unboxingUpdateEnabled={props.unboxingUpdateEnabled} />
  ));

  return (
    <div className='Steps'>
      <h3 className={props.unboxingUpdateEnabled ? 'sectionHeader' : 'h2'} id={props.slug}>{props.title}</h3>
      <div className='paragraph'>{props.summary}</div>
      {steps}
    </div>
  );
};

Steps.propTypes = {
  ...instructionsPropTypes,
  unboxingUpdateEnabled: PropTypes.bool,
};

Steps.defaultProps = {
  unboxingUpdateEnabled: false,
};

export default Steps;



// WEBPACK FOOTER //
// ./app/components/support/entries/steps.jsx